import { Box, Flex } from '@podiumhq/design-system';
import { motion } from 'framer-motion';

import BusinessText from '../../components/BusinessText';
import WebchatWidget from '../../components/Webchat';
import WebchatForm from '../../components/WebchatForm';
import {
  businessContent,
  testimonialText,
  testimonialAttribution,
} from './content';
import Testimonial from '../../components/Testimonial';
import testimonialImage from '../../assets/webchat-testimonial.png';
import { getFadeUpAnimationProps, getPopAnimationProps } from '../../utils';

const Webchat = () => (
  <>
    <Box mt="40px">
      <WebchatWidget />
    </Box>
    <Flex justifyContent="flex-end">
      <motion.div
        {...getPopAnimationProps(2.1, 0.65)}
        style={{
          transformOrigin: 'bottom right',
          position: 'relative',
          top: '-20px',
        }}
      >
        <WebchatForm />
      </motion.div>
    </Flex>
    <Box mt="10px">
      <motion.div {...getPopAnimationProps(2.8, 0.6)}>
        <BusinessText content={businessContent} contentWidth="100%" />
      </motion.div>
    </Box>
    <Box mt="40px">
      <motion.div {...getFadeUpAnimationProps(3.75, 0.3)}>
        <Testimonial
          image={testimonialImage}
          text={testimonialText}
          attribution={testimonialAttribution}
        />
      </motion.div>
    </Box>
  </>
);

export default Webchat;
